import axios from "axios";
import moment from "moment";
import React, {useContext, useEffect, useRef, useState} from "react";
import { Button, Form, Modal, Nav, Navbar } from "react-bootstrap";
import Iframe from "react-iframe";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link, NavLink, useHistory } from "react-router-dom";
import { LocationContext } from "../../../CustomHelper/Helper";
import {
  default as helloSuperstarLogo,
  default as Logo,
} from "../../../Assets/Icon/HelloSuperStarLogo.png";
import Momotaz from "../../../Assets/Images/no-image.png";
import accountImg from "../../../Assets/Images/no-image.png";
import Shakib from "../../../Assets/Images/no-image.png";
import ShahRukhKhan from "../../../Assets/Images/no-image.png";
import "../../CSS/Navbar/navbar.css";
import ApprovedImg from "../Header/NotificationDropdownModal/defultImg/approved.png";
import GreetingImg from "../Header/NotificationDropdownModal/defultImg/greetings.png";

import "./Navigation.css";
import NotificationDropdownModal from "./NotificationDropdownModal/NotificationDropdownModal";

import MessageSkliton from "./MessageSkliton";
import NotifySkliton from "./NotifySkliton";

import NotificationSkeleton from "./NotificationSkeleton";
import NavigationTimer from "./NavigationTimer";
import { serverInfo } from "../../../App";
import {useI18n} from "../../../i18n";
import {useTranslation} from "react-i18next";

import { generateToken, messaging } from "../../../../src/notifications/firebase";
import { onMessage } from "firebase/messaging";
import swal from "sweetalert";

import { NotificationContext } from '../../../notifications/NotificationContext';




const Navigation = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const { allCurrency, slectedCurrency, setSlectedCurrency } =
    useContext(LocationContext);


  const [notiDropdownShow, setNotiDropdownShow] = React.useState(false);
  const [userInfo, setUserInfo] = React.useState({});
  const [navigation, setNavigation] = useState("home");

  const [isChatOpen, setIsChatOpen] = useState(false);

  const [countryCode, setCountryCode] = useState();

  const [notificationChatDropdown, setNotificationChatDropdown] =
    useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [notifictions, setNotifictions] = useState([]);
  const [greetingInfo, setGreetingInfo] = useState([]);
  const [greetinsTyps, setGreetinsTyps] = useState([]);
  const [auctionInfo, setAuctionInfo] = useState([]);
  const [fanGroup, setFanUserGroup] = useState([]);
  const [totalNotification, setTotalNotification] = useState();
  const [totalSpinNotification, setTotalSpinNotification] = useState(0);
  const [load, setLoad] = useState(true);

  const [notificationsSpin, setNotificationsSpin] = useContext(NotificationContext);

  

  const searchInputRef = useRef(null);
  const search2InputRef = useRef(null);
  const history = useHistory();
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  // const { t } = useI18n();

  useEffect(() => {
    onMessage(messaging, (payload) => {
      // Assuming payload contains the notification data
      const newNotification = {
        message: payload.notification.body, // You can customize this with other payload data
        time: new Date().toLocaleTimeString(), // Optionally add time of arrival
      };

      handleNotificationDropdown();

      // Update notifications list in localStorage
      storeNotification(newNotification);
    });
  }, []);

  const storeNotification = (newNotification) => {
    setNotificationsSpin((prevNotifications) => {
      const updatedNotifications = [...prevNotifications, newNotification];
      localStorage.setItem('notifications', JSON.stringify(updatedNotifications));
      return updatedNotifications;
    });
  };


  const handleNotificationClick = (index) => {
    // Redirect to /lucky-spin
    history.push(`/lucky-spin`);
  
    const updatedNotifications = notificationsSpin.filter((_, i) => i !== index);
    setNotificationsSpin(updatedNotifications);
    localStorage.setItem('notifications', JSON.stringify(updatedNotifications));
  };

  useEffect(() => {
    getUserInformation();
    localStorage.getItem("auth_token") &&
      axios.get(`/api/user/total_notification_count`).then((res) => {
        if (res.data.status === 200) {
          setTotalNotification(res.data.totalNotification);
        }
      });

    localStorage.getItem("auth_token") &&
      axios.get(`/api/user/fan/group/list`).then((res) => {
        if (res.data.status === 200) {
          setFanUserGroup(res.data.useFanGroup);
        }
      });


  }, []);

  let checkNotification = () => {
    localStorage.getItem("auth_token") &&
      axios.get("/api/user/check_notification").then((res) => {
        if (res.data.status === 200) {
          setNotifictions(res.data.notifiction);
          setGreetingInfo(res.data.greeting_info);
          setGreetinsTyps(res.data.greeting_type);
          setAuctionInfo(res.data.auctionInfo);
          setLoad(false);
        }
      });
  };

  useEffect(() => {}, []);

  const handleCurrencyValue = (data) => {
    let CurrencyValue = data.split("_");

    setSlectedCurrency({
      currency_value: CurrencyValue[0],
      countryCode: CurrencyValue[1],
      symbol: CurrencyValue[2],
      min: CurrencyValue[3],
      hour: CurrencyValue[4],
      timeAction: CurrencyValue[5],
    });
  };

  let getUserInformation = () => {
    localStorage.getItem("auth_token") &&
      axios.get(`api/user_info`).then((res) => {
        if (res.data.status === 200) {
          setUserInfo(res.data.users);
        }
      });
  };

  const [changeIcon, setChange] = useState(false);
  function handleChangeIcon() {
    setChange(!changeIcon);
  }

  const handleChatIsOpen = () => {
    setIsChatOpen(!isChatOpen);
    setNavigation("messenger");
  };

  const handleNotificationDropdown = () => {
    checkNotification();
    setNotificationChatDropdown(!notificationChatDropdown);
    setNavigation("notification");
  };

  const greetingsDetailsForm = (
    notification_id,
    view_status,
    event_type = null,
    event_id = null
  ) => {
    axios
      .get(`/api/user/notification/view_status/update/${notification_id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setTotalNotification(totalNotification - 1);
        }
      });

    if (event_type === "Greeting" || event_type === "Greetings") {
      // history.push({
      //   pathname: `/greeting-registration/${event_id}/${notification_id}`,
      // });
      history.push({
        pathname: `/activities`,
      });
    } else {
      history.push({
        pathname: `/`,
      });
      // history.push({
      //   pathname: `/activities`,
      // });
      // history.push({
      //   pathname: `/starprofile/${greetingInfo.star_id}/greetings_registration_form`,
      //   state: {
      //     greetingInfo: greetingInfo,
      //     notification_id: notification_id,
      //     greetins_typs: greetinsTyps,
      //   },
      // });
    }
  };

  const [searchData, setSearchData] = useState("");
  const slugData = ""
  //const slugData = JSON.parse(localStorage.getItem("searchSlug"));

  useEffect(() => {
    if (slugData) {
      //setSearchData(slugData);
    }
  }, [slugData]);

  

  const handleSubmit = (e) => {
    e.preventDefault();

    if (searchData == undefined || searchData == '' || searchData.trim() == '') {
      return;
    } else {
      if (searchInputRef.current) {
        searchInputRef.current.value = '';
      }
      if (search2InputRef.current) {
        search2InputRef.current.value = '';
      }
      localStorage.setItem("searchSlug", JSON.stringify(searchData));
      history.push(`/search/${searchData}`);
    }



  };

  const handlePress = (data) => {
    data?.notification_text?.type === "auction"
      ? handleAuction(data.id, data.event_id, Number(data.view_status))
      : greetingsDetailsForm(
          data.id,
          Number(data.view_status),
          data.notification_text.type,
          data.event_id
        );
  };
  const handleAuction = (notificationId, id, viewStatus) => {
    if (Number(viewStatus) === 0) {
      axios
        .get(`/api/user/notification/view_status/update/${notificationId}`)
        .then((res) => {
          if (res.data.status === 200) {
            setTotalNotification(totalNotification - 1);
          }
        });
    }
    history.push(`/auction/${id}`);
  };

  useEffect(() => {
    setTotalSpinNotification((prevCount) => prevCount + (notificationsSpin.length - prevCount));
    if(notificationsSpin.length > 0){
      handleNotificationDropdown();
    }
  }, [notificationsSpin]); 

  return (
    <>
      <div className="Mobile">
        <div className="d-flex justify-content-between align-items-center p-2 SearchBox">
          <div className="mobile-img-logo">
            <img src={Logo} alt="" width={60} height={60} />
          </div>

          <form onSubmit={handleSubmit} role="search" className="col-8">
            <input
              type="search"
              placeholder={t('Search_Superstars_Text')}
              className="form-control searchMo"
              onChange={(e) => setSearchData(e.target.value)}
            />
          </form>
        </div>
      </div>

      <div className="sticky-top navbar-height">
        {/* Mobile & Tab Navbar */}
        <div className="Mobile ">
          <div className="d-flex MenuColor justify-content-between p-3">
            <div className=" smallNav">
              {navigation === "home" ? (
                <NavLink className="active-link" to="/">
                  <i className="fa fa-home smallNavCirHome circle-icon circle-icon-x" />
                </NavLink>
              ) : (
                <NavLink
                  onClick={() => setNavigation("home")}
                  className="active-link "
                  to="/"
                >
                  <i className="fa fa-home smallNavCirHome " />
                </NavLink>
              )}
            </div>

            {/* Message */}
            {/* {navigation === "messenger" ? <></> : <></>} */}

            <div className=" smallNav dropdownNavMe">
              <div className="active-link dropBtnNav Mobi-lab" to="/">
                <i className="fa-solid fa-comment smallNavCir circle-icon circle-icon-x" />
                {/* {totalNotification ? (
                  <span className="text-light mobil-lab-b text-center">1</span>
                ) : (
                  ""
                )} */}
              </div>

              <div className="dropNav-content py-3">
                <div className="container mb-4 mt-2 form-group has-search">
                  <span className="fa fa-search form-control-feedback"></span>
                  <Form onSubmit={handleSubmit}>
                    <input
                      type="text"
                      className="form-control search-design"
                      placeholder={t('Search_Superstars_Text')}
                      // value={searchData}
                      onChange={(e) => setSearchData(e.target.value)}
                    />
                  </Form>
                </div>
                {fanGroup.map((fan, index) => (
                  <div key={index}>
                    <Link to={`group/${fan.slug}`}>
                      <div className="d-flex justify-content-between mx-2 BorderBottomNo">
                        {" "}
                        <div className="d-flex">
                          <img
                            className="img-fluid liveChatVideoPic"
                            style={{
                              width: "55px",
                              height: "55px",
                              borderRadius: "50%",
                            }}
                            src={imageCdnUrl + fan.banner}
                            alt=""
                          />
                          <div className="text-white ms-2 mt-1 profileName">
                            <div className="text-decoration-none">
                              <h6 className="text-margin-bottom">
                                <b>{fan.group_name}</b>
                              </h6>
                              <p className="text-margin-bottom">
                                <small>Join to live Chat</small>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="timeStampColor">
                          <div className="d-flex text-warning">
                            <div className="timeStamp-text-icon">
                              <i className="mt-1 me-2 far fa-clock"></i>
                            </div>
                            <b>
                              <p className="mt-1">
                                <NavigationTimer
                                  event_start_date={fan.start_date}
                                ></NavigationTimer>
                              </p>
                            </b>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>

            {/* Message End*/}

            {/* {navigation === "notification" ? <></> ( ) : ( <> </>   )} */}

            {/* Notification */}
            <div className=" smallNav dropdownNavMe">
              <div
                onClick={handleNotificationDropdown}
                className="active-link dropBtnNav Mobi-lab"
              >
                <i className="fa-solid fa-bell smallNavCir circle-icon circle-icon-x" />
                {totalNotification ? (
                  <span className="text-light mobil-lab-b text-center">
                    {totalNotification}
                  </span>
                ) : (
                  ""
                )}
              </div>

              <div className="dropNav-content py-3">
                {load
                  ? [1, 2, 3].map((data, i) => (
                      <div key={i}>
                        <NotifySkliton />
                      </div>
                    ))
                  : notifictions.map((data, i) => (
                      <div
                        className="d-flex justify-content-between m-2 BorderBottomNo"
                        key={i}
                        onClick={() =>
                          greetingsDetailsForm(
                            data?.id,
                            Number(data?.view_status),
                            data?.notification_text?.type,
                            data?.event_id
                          )
                        }
                      >
                        <div
                          className={`d-flex justify-content-between  w-100 ${
                            data.view_status == 0 ? "unseen p-2" : ""
                          }`}
                        >
                          <div className="d-flex">
                            <img
                              className="img-fluid liveChatVideoPic"
                              style={{
                                width: "55px",
                                height: "55px",
                                borderRadius: "50%",
                              }}
                              src={ApprovedImg}
                              alt=""
                            />
                            <div className="text-white ms-1 mt-1 profileName">
                              <div className="text-decoration-none">
                                <h6 className="text-margin-bottom">
                                  <b>{data?.notification_text?.type}</b>
                                </h6>
                                <p className="text-margin-bottom">
                                  <small>{data.notification_text?.text}</small>
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="timeStampColor">
                            <p className="text-margin-bottom">
                              {moment(data.created_at).format("hh:mm A")}
                            </p>
                            <p className="text-margin-bottom">
                              <small>
                                {" "}
                                {moment(data.created_at).format("LL")}
                              </small>
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
              </div>
            </div>

            {/* Notification End */}

            <div className=" smallNav">
              {navigation === "video" ? (
                <NavLink className="active-link" to="/video">
                  <i className="fa-solid fa-video smallNavCir circle-icon circle-icon-x" />
                </NavLink>
              ) : (
                <NavLink
                  onClick={() => setNavigation("video")}
                  className="active-link"
                  to="/video"
                >
                  <i className="fa-solid fa-video smallNavCir " />
                </NavLink>
              )}
            </div>

            <div className=" smallNav">
              {navigation === "marketplace" ? (
                <NavLink className="active-link" to="/marketplace">
                  <i className="fa fa-store smallNavCirHome circle-icon circle-icon-x" />
                </NavLink>
              ) : (
                <NavLink
                  onClick={() => setNavigation("marketplace")}
                  className="active-link"
                  to="/marketplace"
                >
                  <i className="fa fa-store smallNavCirHome " />
                </NavLink>
              )}
            </div>

            {/* Menu */}
            <div className=" smallNav">
              {navigation === "menuNav" ? (
                <NavLink className="active-link" to="/menu">
                  <i className="fa-solid fa-bars smallNavCirHome circle-icon circle-icon-x" />
                </NavLink>
              ) : (
                <NavLink
                  onClick={() => setNavigation("menuNav")}
                  className="active-link"
                  to="/menu"
                >
                  <i className="fa-solid fa-bars smallNavCirHome " />
                </NavLink>
              )}
            </div>
          </div>
        </div>
        {/* Mobile & Tab Navbar End */}

        <Navbar className="navbar-bg navbar-position " expand="lg">
          <div className="container-fluid  custom-container-nv ">
            <Navbar.Brand href="#">
              <NavLink to="/">
                {" "}
                <img
                  src={helloSuperstarLogo}
                  alt="hello superstar logo"
                  className="log-navbar"
                />
              </NavLink>
            </Navbar.Brand>
            {changeIcon ? (
              <Form
                className="form-width-change"
                onClick={handleChangeIcon}
                onSubmit={handleSubmit}
              >
                <div className="form-group has-search">
                  <span className="fa-solid fa-arrow-left-long form-control-feedback"></span>
                  <input
                    ref={searchInputRef}
                    type="text"
                    className="form-control search-design SearchNav "
                    placeholder={t('Search_Superstars_Text')}
                    onChange={(e) => setSearchData(e.target.value)}
                  />
                </div>

              </Form>
            ) : (
              <Form
                className="form-width-change"
                onClick={handleChangeIcon}
                onSubmit={handleSubmit}
              >
                <div className="form-group has-search">
                  <span className="fa fa-search form-control-feedback"></span>
                  <input
                    ref={search2InputRef}
                    type="text"
                    className="form-control search-design SearchNav "
                    placeholder= {t('Search_Superstars_Text')}
                    // value={searchData}
                    onChange={(e) => setSearchData(e.target.value)}
                  />
                </div>
              </Form>
            )}

            <Navbar.Toggle aria-controls="navbarScroll" />
            <Navbar.Collapse id="navbarScroll">
              <Nav className="ms-auto my-2 my-lg-0 " navbarScroll>
                {navigation === "home" ? (
                  <Nav.Link as={Link} className="ms-2 text-center" to="/">
                    <i className="fa fa-home nav-icon-active " />
                    <p className="p-0 m-0 nav-text-active">{t('Home_Text')}</p>
                  </Nav.Link>
                ) : (
                  <Nav.Link
                    as={Link}
                    onClick={() => setNavigation("home")}
                    className="ms-2 text-center"
                    to="/"
                  >
                    <i className="fa fa-home nav-icon-new " />
                    <p className="p-0 m-0 nav-text">{t('Home_Text')}</p>
                  </Nav.Link>
                )}

                {navigation === "video" ? (
                  <Nav.Link as={Link} className="ms-2 text-center" to="/video">
                    <i className="fa fa-video nav-icon-active " />
                    <p className="p-0 m-0 nav-text-active">{t('Videos_Text')}</p>
                  </Nav.Link>
                ) : (
                  <Nav.Link
                    as={Link}
                    onClick={() => setNavigation("video")}
                    to="/video"
                    className="ms-2 text-center"
                  >
                    <i className="fa fa-video nav-icon-new " />
                    <p className="p-0 m-0 nav-text">{t('Videos_Text')}</p>
                  </Nav.Link>
                )}

                {/*{navigation === "messenger" ? (*/}
                {/*  <Nav.Link*/}
                {/*    onClick={handleChatIsOpen}*/}
                {/*    className="ms-2 text-center"*/}
                {/*  >*/}
                {/*    <div className="dropdown dropDownIconRemove">*/}
                {/*      <div*/}
                {/*        className="dropdown-toggle"*/}
                {/*        id="dropdownMenuButton1"*/}
                {/*        data-bs-toggle="dropdown"*/}
                {/*        aria-expanded="false"*/}
                {/*      >*/}
                {/*        <i className="fa fa-message nav-icon-active " />*/}
                {/*        <p className="p-0 m-0 nav-text-active">Message 123</p>*/}
                {/*      </div>*/}

                {/*      <div*/}
                {/*        className="container chatContainer dropdown-menu toggle"*/}
                {/*        aria-labelledby="dropdownMenuButton1"*/}
                {/*      >*/}
                {/*        <div className="container mb-4 mt-2 form-group has-search">*/}
                {/*          <span className="fa fa-search form-control-feedback"></span>*/}
                {/*          <Form onSubmit={handleSubmit}>*/}
                {/*            <input*/}
                {/*              type="text"*/}
                {/*              className="form-control search-design"*/}
                {/*              placeholder="Search Superstar"*/}
                {/*              onChange={(e) => setSearchData(e.target.value)}*/}
                {/*            />*/}
                {/*          </Form>*/}
                {/*        </div>*/}

                {/*        {fanGroup.map((fan, index) => (*/}
                {/*          <div key={index}>*/}
                {/*            <div className="d-flex justify-content-between m-3">*/}
                {/*              <div className="d-flex">*/}
                {/*                <img*/}
                {/*                  className="img-fluid liveChatVideoPic"*/}
                {/*                  style={{*/}
                {/*                    width: "55px",*/}
                {/*                    height: "55px",*/}
                {/*                    borderRadius: "48%",*/}
                {/*                  }}*/}
                {/*                  src={imageCdnUrl + fan.banner}*/}
                {/*                  alt=""*/}
                {/*                />*/}

                {/*                <div className="text-white ms-1 profileName">*/}
                {/*                  /!* <a*/}
                {/*                    className="text-decoration-none"*/}
                {/*                    href="https://superstar-livechat.herokuapp.com/?room=SuperStarLiveConversation_algdxhxmio8"*/}
                {/*                  > *!/*/}
                {/*                  <Link*/}
                {/*                    to={`group/${fan.slug}`}*/}
                {/*                    className="link-open"*/}
                {/*                  >*/}
                {/*                    <p className="text-margin-bottom">*/}
                {/*                      <b>{fan.group_name}</b>*/}
                {/*                    </p>*/}

                {/*                    <p className="text-margin-bottom">*/}
                {/*                      <small>Join Chat Room</small>*/}
                {/*                    </p>*/}
                {/*                  </Link>*/}
                {/*                </div>*/}
                {/*              </div>*/}

                {/*              <div className="timeStampColor">*/}
                {/*                <div className="d-flex text-warning">*/}
                {/*                  <NavigationTimer*/}
                {/*                    event_start_date={fan.start_date}*/}
                {/*                  ></NavigationTimer>*/}
                {/*                </div>*/}
                {/*              </div>*/}
                {/*            </div>*/}
                {/*          </div>*/}
                {/*        ))}*/}
                {/*      </div>*/}
                {/*    </div>*/}
                {/*  </Nav.Link>*/}
                {/*) : (*/}
                {/*  <Nav.Link*/}
                {/*    onClick={handleChatIsOpen}*/}
                {/*    className="ms-2 text-center"*/}
                {/*  >*/}
                {/*    <div className="dropdown dropDownIconRemove">*/}
                {/*      <div*/}
                {/*        className="dropdown-toggle"*/}
                {/*        id="dropdownMenuButton1"*/}
                {/*        data-bs-toggle="dropdown"*/}
                {/*        aria-expanded="false"*/}
                {/*      >*/}
                {/*        <i className="fa fa-message nav-icon-new " />*/}
                {/*        <p className="p-0 m-0 nav-text">Message 456</p>*/}
                {/*      </div>*/}

                {/*      <div*/}
                {/*        className="container chatContainer dropdown-menu toggle"*/}
                {/*        aria-labelledby="dropdownMenuButton1"*/}
                {/*      >*/}
                {/*        <div className="container mb-4 mt-2 form-group has-search">*/}
                {/*          <span className="fa fa-search form-control-feedback"></span>*/}
                {/*          <Form onSubmit={handleSubmit}>*/}
                {/*            <input*/}
                {/*              type="text"*/}
                {/*              className="form-control search-design"*/}
                {/*              placeholder="Search Superstar"*/}
                {/*              onChange={(e) => setSearchData(e.target.value)}*/}
                {/*            />*/}
                {/*          </Form>*/}
                {/*        </div>*/}

                {/*        <div*/}
                {/*        // onClick="parent.open('https://superstar-livechat.herokuapp.com/?room=SuperStarLiveConversation_algdxhxmio8')"*/}
                {/*        >*/}
                {/*          <div className="d-flex justify-content-between m-3">*/}
                {/*            <div className="d-flex">*/}
                {/*              <img*/}
                {/*                className="img-fluid liveChatVideoPic"*/}
                {/*                style={{*/}
                {/*                  width: "55px",*/}
                {/*                  height: "55px",*/}
                {/*                  borderRadius: "48%",*/}
                {/*                }}*/}
                {/*                src={Shakib}*/}
                {/*                alt=""*/}
                {/*              />*/}
                {/*              <div className="text-white ms-1 profileName">*/}
                {/*                /!* <a*/}
                {/*                  className="text-decoration-none"*/}
                {/*                  href="https://superstar-livechat.herokuapp.com/?room=SuperStarLiveConversation_algdxhxmio8"*/}
                {/*                > *!/*/}
                {/*                <button*/}
                {/*                  // onClick="parent.open('https://superstar-livechat.herokuapp.com/?room=SuperStarLiveConversation_algdxhxmio8')"*/}
                {/*                  className="link-open"*/}
                {/*                >*/}
                {/*                  <p className="text-margin-bottom">*/}
                {/*                    <b>Shakib Al Hasan</b>*/}
                {/*                  </p>*/}
                {/*                  <p className="text-margin-bottom">*/}
                {/*                    <small>You have a schedule</small>*/}
                {/*                  </p>*/}
                {/*                </button>*/}
                {/*                /!* </a> *!/*/}
                {/*              </div>*/}
                {/*            </div>*/}

                {/*            <div className="timeStampColor">*/}
                {/*              <div className="d-flex text-warning">*/}
                {/*                <div className="timeStamp-text-icon">*/}
                {/*                  <i className="mt-1 me-2 far fa-clock"></i>*/}
                {/*                </div>*/}
                {/*                <b>*/}
                {/*                  <p className="mt-1">1m 20s</p>*/}
                {/*                </b>*/}
                {/*              </div>*/}
                {/*            </div>*/}
                {/*          </div>*/}
                {/*        </div>*/}

                {/*        <div*/}
                {/*          // onClick="parent.open('https://superstar-livechat.herokuapp.com/?room=SuperStarLiveConversation_algdxhxmio8')"*/}
                {/*          className="mt-4"*/}
                {/*        >*/}
                {/*          <div className="d-flex justify-content-between m-3">*/}
                {/*            <div className="d-flex">*/}
                {/*              <img*/}
                {/*                className="img-fluid liveChatVideoPic"*/}
                {/*                style={{*/}
                {/*                  width: "55px",*/}
                {/*                  height: "55px",*/}
                {/*                  borderRadius: "48%",*/}
                {/*                }}*/}
                {/*                src={Momotaz}*/}
                {/*                alt=""*/}
                {/*              />*/}
                {/*              <div className="text-white ms-1 mt-1 profileName">*/}
                {/*                /!* <a*/}
                {/*                  className="text-decoration-none"*/}
                {/*                  href="https://superstar-livechat.herokuapp.com/?room=SuperStarLiveConversation_algdxhxmio8"*/}
                {/*                > *!/*/}
                {/*                <button*/}
                {/*                  // onClick="parent.open('https://superstar-livechat.herokuapp.com/?room=SuperStarLiveConversation_algdxhxmio8')"*/}
                {/*                  className="link-open"*/}
                {/*                >*/}
                {/*                  <p className="text-margin-bottom">*/}
                {/*                    <b>Momotaz Begum</b>*/}
                {/*                  </p>*/}
                {/*                  <p className="text-margin-bottom">*/}
                {/*                    <small>You have a schedule</small>*/}
                {/*                  </p>*/}
                {/*                </button>*/}
                {/*                /!* </a> *!/*/}
                {/*              </div>*/}
                {/*            </div>*/}

                {/*            <div className="timeStampColor">*/}
                {/*              <p className="text-margin-bottom">7/9/2021</p>*/}
                {/*              <p className="text-margin-bottom">*/}
                {/*                <small>5.10 PM</small>*/}
                {/*              </p>*/}
                {/*            </div>*/}
                {/*          </div>*/}
                {/*        </div>*/}

                {/*        <div*/}
                {/*          // onClick="parent.open('https://superstar-livechat.herokuapp.com/?room=SuperStarLiveConversation_algdxhxmio8')"*/}
                {/*          className="mt-4"*/}
                {/*        >*/}
                {/*          <div className="d-flex justify-content-between m-3">*/}
                {/*            <div className="d-flex">*/}
                {/*              <img*/}
                {/*                className="img-fluid liveChatVideoPic"*/}
                {/*                style={{*/}
                {/*                  width: "55px",*/}
                {/*                  height: "55px",*/}
                {/*                  borderRadius: "48%",*/}
                {/*                }}*/}
                {/*                src={ShahRukhKhan}*/}
                {/*                alt=""*/}
                {/*              />*/}
                {/*              <div className="text-white ms-1 profileName">*/}
                {/*                /!* <a*/}
                {/*                  className="text-decoration-none"*/}
                {/*                  href="https://superstar-livechat.herokuapp.com/?room=SuperStarLiveConversation_algdxhxmio8"*/}
                {/*                > *!/*/}
                {/*                <button*/}
                {/*                  // onClick="parent.open('https://superstar-livechat.herokuapp.com/?room=SuperStarLiveConversation_algdxhxmio8')"*/}
                {/*                  className="link-open"*/}
                {/*                >*/}
                {/*                  <p className="text-margin-bottom">*/}
                {/*                    <b>Shahrukh Khan</b>*/}
                {/*                  </p>*/}
                {/*                  <p className="text-margin-bottom">*/}
                {/*                    <small>You have a schedule</small>*/}
                {/*                  </p>*/}
                {/*                </button>*/}
                {/*                /!* </a> *!/*/}
                {/*              </div>*/}
                {/*            </div>*/}

                {/*            <div className="timeStampColor">*/}
                {/*              <p className="text-margin-bottom">7/9/2021</p>*/}
                {/*              <p className="text-margin-bottom">*/}
                {/*                <small>5.10 PM</small>*/}
                {/*              </p>*/}
                {/*            </div>*/}
                {/*          </div>*/}
                {/*        </div>*/}

                {/*        <div onClick={handleShow} className="mt-4">*/}
                {/*          <div className="d-flex justify-content-between m-3">*/}
                {/*            <div className="d-flex">*/}
                {/*              <img*/}
                {/*                className="img-fluid liveChatVideoPic"*/}
                {/*                style={{*/}
                {/*                  width: "55px",*/}
                {/*                  height: "55px",*/}
                {/*                  borderRadius: "48%",*/}
                {/*                }}*/}
                {/*                src={Shakib}*/}
                {/*                alt=""*/}
                {/*              />*/}
                {/*              <div className="text-white ms-1 profileName">*/}
                {/*                /!* <a className="text-decoration-none"> *!/*/}
                {/*                <button className="link-open">*/}
                {/*                  <p className="text-margin-bottom">*/}
                {/*                    <b>Mustafizur Rahman</b>*/}
                {/*                  </p>*/}
                {/*                  <p className="text-margin-bottom">*/}
                {/*                    <small>You have a schedule</small>*/}
                {/*                  </p>*/}
                {/*                </button>*/}
                {/*                /!* </a> *!/*/}
                {/*              </div>*/}
                {/*            </div>*/}

                {/*            <div className="timeStampColor">*/}
                {/*              <p className="text-margin-bottom">7/9/2021</p>*/}
                {/*              <p className="text-margin-bottom">*/}
                {/*                <small>5.10 PM</small>*/}
                {/*              </p>*/}
                {/*            </div>*/}
                {/*          </div>*/}
                {/*        </div>*/}
                {/*      </div>*/}
                {/*    </div>*/}
                {/*  </Nav.Link>*/}
                {/*)}*/}

                {/* Notification Dropdown */}
                {navigation === "notification" ? (
                  <Nav.Link
                    onClick={handleNotificationDropdown}
                    className="ms-2 text-center"
                  >
                    <div className="dropdown dropDownIconRemove">
                      <div
                        className="dropdown-toggle"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {!totalNotification ? (
                          <span className="notification_counter">
                            {totalSpinNotification}
                          </span>
                        ) : (
                          ""
                        )}

                        <i className="fa fa-bell nav-icon-active " />
                        <p className="p-0 m-0 nav-text-active">{t('Notification_Text')}</p>
                      </div>

                      <div
                        className="container chatContainer dropdown-menu toggle"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        {load
                          ? [1, 2, 3].map((data, i) => (

                              <div key={i}>
                                <NotificationSkeleton></NotificationSkeleton>
                              </div>
                            ))
                          : notifictions.map((data, i) => (
                              <div
                                key={i}
                                className="borderBottomNotificationDropdown"
                                onClick={
                                  () => handlePress(data)
                                  // greetingsDetailsForm(
                                  //   data?.id,
                                  //   Number(data?.view_status),
                                  //   data?.notification_text?.type,
                                  //   data?.event_id
                                  // )
                                }
                              >
                                <div
                                  className={`d-flex justify-content-between m-2 p-2 ${
                                    data.view_status == 0 ? "unseen" : ""
                                  }`}
                                >
                                  <div className="d-flex">
                                    <img
                                      className="img-fluid liveChatVideoPic"
                                      style={{
                                        width: "55px",
                                        height: "55px",
                                        borderRadius: "48%",
                                      }}
                                      src={GreetingImg}
                                      alt=""
                                    />

                                    <div className="text-white ms-1 mt-1 profileName">
                                      <div className="text-decoration-none">
                                        <div className="link-open">
                                          <h6 className="text-margin-bottom">
                                            <b>
                                              {data?.notification_text?.type}
                                            </b>
                                          </h6>
                                          <p className="text-margin-bottom">
                                            <small>
                                              {data.notification_text?.text}
                                            </small>
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="timeStampColor">
                                    <p className="text-margin-bottom">
                                      <small>
                                        {moment(data.created_at).format(
                                          "hh:mm A"
                                        )}
                                      </small>
                                      <br></br>
                                      <small>
                                        {moment(data.created_at).format("LL")}
                                      </small>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            ))}
                            <ul className="text-white">
                            {notificationsSpin.map((notif, index) => (
                                <div key={index}>
                                <i className="fa fa-bell me-1 " style={{color: '#e4d759'}} /> 
                                  <span 
                                    onClick={() => handleNotificationClick(index)} 
                                    style={{ cursor: 'pointer', color: '#ffff', marginTop: '3px' }}
                                  >
                                    {notif.message}
                                  </span>
                                </div>
                              ))}
                            </ul>
                        <div>
                        {
                            load ? (
                              <button className="btn btn-warning w-100">
                                {t('Loading_tex')}
                              </button>
                            ) : notificationsSpin.length > 0 ? (
                              // Render your notifications list here, you can map over the notificationsSpin array
                              notificationsSpin.map((notification, index) => (
                               ' '
                              ))
                            ) : (
                              <div className="no-link notify-text w-100">
                                {t('No_Notification_Text')}
                              </div>
                            )
                          }
                        </div>
                      </div>
                    </div>
                  </Nav.Link>
                ) : (
                  <Nav.Link
                    onClick={handleNotificationDropdown}
                    className="ms-2 text-center"
                  >
                    <div className="dropdown dropDownIconRemove">
                      <div
                        className="dropdown-toggle"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        style={{ position: "relative" }}
                      >
                        {totalNotification ? (
                          <span className="notification_counter">
                            {totalNotification}
                          </span>
                        ) : (
                          ""
                        )}
                        <i className="fa fa-bell nav-icon-new " />
                        <p className="p-0 m-0 nav-text"> {t('Notification_Text')}</p>
                      </div>

                      <div
                        className="container chatContainer dropdown-menu toggle"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        {load
                          ? [1].map((data, i) => (
                              <div key={i}>
                                <SkeletonTheme
                                  baseColor="#202020"
                                  highlightColor="#444"
                                >
                                  <div className="borderBottomNotificationDropdown">
                                    <div className="d-flex justify-content-between m-2">
                                      <div className="d-flex">
                                        <Skeleton
                                          height={55}
                                          width={55}
                                          circle={true}
                                        />

                                        <div className="text-white ms-1 profileName">
                                          <div className="text-decoration-none">
                                            <div className="link-open px-2 py-2">
                                              <Skeleton
                                                width={180}
                                                height={15}
                                              />
                                              <Skeleton
                                                width={200}
                                                height={10}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="timeStampColor"></div>
                                    </div>
                                  </div>
                                </SkeletonTheme>
                              </div>
                            ))
                          : notifictions.map((data, i) => (
                              <div
                                key={i}
                                className="borderBottomNotificationDropdown"
                                onClick={() =>
                                  greetingsDetailsForm(
                                    data?.id,
                                    Number(data?.view_status),
                                    data?.notification_text?.type,
                                    data?.event_id
                                  )
                                }
                              >
                                <div className="d-flex justify-content-between m-2">
                                  <div className="d-flex">
                                    <img
                                      className="img-fluid liveChatVideoPic"
                                      style={{
                                        width: "55px",
                                        height: "55px",
                                        borderRadius: "48%",
                                      }}
                                      src={ApprovedImg}
                                      alt=""
                                    />

                                    <div className="text-white ms-1 mt-1 profileName">
                                      <div className="text-decoration-none">
                                        <div className="link-open">
                                          <h6 className="text-margin-bottom">
                                            <b>
                                              {data?.notification_text?.type}
                                            </b>
                                          </h6>
                                          <p className="text-margin-bottom">
                                            <small>
                                              {data.notification_text?.text}
                                            </small>
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="timeStampColor">
                                    <p className="text-margin-bottom">
                                      <small>
                                        {moment(data.created_at).format("LL")}
                                      </small>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            ))}
                        
                        <div>
                          <button className="btn btn-warning w-100">
                            {t('See_More_Text')}
                          </button>
                        </div>
                      </div>
                    </div>
                  </Nav.Link>
                )}

                {navigation === "marketplace" ? (
                  <Nav.Link
                    as={Link}
                    className="ms-2 text-center"
                    to="/marketplace"
                  >
                    <i className="fa fa-store nav-icon-active " />
                    <p className="p-0 m-0 nav-text-active">{t('EShowcase_Text')}</p>
                  </Nav.Link>
                ) : (
                  <Nav.Link
                    as={Link}
                    className="ms-2 text-center"
                    onClick={() => setNavigation("marketplace")}
                    to="/marketplace"
                  >
                    <i className="fa fa-store nav-icon-new " />
                    <p className="p-0 m-0 nav-text">{t('EShowcase_Text')}</p>
                  </Nav.Link>
                )}

                {navigation === "profile" ? (
                  <Nav.Link
                    as={Link}
                    className="ms-2 text-center"
                    to="/profile"
                  >
                    <img
                      src={
                        userInfo?.image != null
                          ? imageCdnUrl + userInfo?.image
                          : accountImg
                      }
                      className="img-fluid nav-img-new"
                      alt="account create "
                    />
                    <p className="p-0 m-0 nav-text-active"> {t('My_Profile_Text')}</p>
                  </Nav.Link>
                ) : (
                  <Nav.Link
                    as={Link}
                    className="ms-2 text-center"
                    to="/profile"
                    onClick={() => setNavigation("profile")}
                  >
                    <img
                      src={
                        userInfo?.image != null
                          ? imageCdnUrl + userInfo?.image
                          : accountImg
                      }
                      className="img-fluid nav-img-new"
                      alt="account create "
                    />
                    <p className="p-0 m-0 nav-text">{t('My_Profile_Text')}</p>
                  </Nav.Link>
                )}

                <Nav.Link>
                  <select
                    id=""
                    className="language-select"
                    onChange={(e) => handleCurrencyValue(e.target.value)}
                    name={countryCode}
                    style={{ color: "black" }}
                  >
                    {/*<option>--select--</option>*/}
                    {allCurrency?.map((currency, i) => (
                      <option
                        key={i}
                        value={
                          currency?.currency_value +
                          "_" +
                          currency?.country_code +
                          "_" +
                          currency?.symbol +
                          "_" +
                          currency?.minute +
                          "_" +
                          currency?.hours +
                          "_" +
                          currency?.time_action
                        }
                        className="bg-dark"
                        selected={
                          slectedCurrency.countryCode == currency?.country_code
                            ? true
                            : false
                        }
                        style={{ color: "#fff" }}
                      >
                        {currency?.currency_code} ({currency?.symbol})
                      </option>
                    ))}

                    {/* <option selected={countryCode == currency?.country_code ? countryCode : currency?.currency_code} onChange={countryCode == currency?.country_code ? handleCurrency(currency?.currency_value) : ''} value={currency?.currency_value} className="bg-dark">
                      {currency?.currency_code} ({currency?.symbol})
                    </option> */}
                  </select>
                </Nav.Link>
                <Nav.Link>
                  <select className="language-select"  style={{ color: "black" }} onChange={(e) => changeLanguage(e.target.value)} value={i18n.language}>
                    <option  className="bg-dark" style={{ color: "#fff" }} value="en">English</option>
                    <option  className="bg-dark" style={{ color: "#fff" }} value="ba">Bangla</option>
                  </select>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>


          </div>

          <Modal
            dialogClassName="my-modal"
            style={{ height: "100vh" }}
            className="liveChatModalVideo"
            show={show}
            onHide={handleClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <Iframe
                url="https://hellosuperstar-livechat.herokuapp.com/?room=HelloSuperStar-LiveChat_eworfj924t6"
                width="100%"
                height="600px"
                id="myId"
                allow="camera;microphone"
                className="myClassname"
                display="initial"
                position="relative"
              />
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
            </Modal.Body>
          </Modal>

          <NotificationDropdownModal
            show={notiDropdownShow}
            onHide={() => setNotiDropdownShow(false)}
          />
        </Navbar>
      </div>
    </>
  );
};

export default Navigation;
